import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=73d8f8dd&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73d8f8dd')) {
      api.createRecord('73d8f8dd', component.options)
    } else {
      api.reload('73d8f8dd', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=73d8f8dd&", function () {
      api.rerender('73d8f8dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/conversation/contextMenu/Index.vue"
export default component.exports